import { ValidationErrorBoundaryMode, ValidationErrorType, type DeepPartial } from "@ngt-form/core";
import type { MantineFormOptions } from "@ngt-form/mantine";
import { GroupedValidationErrorDisplayFormat } from "@ngt-form/mantine";

import type { AppIconDefinition } from "src/components/common/Icon";
import Icon from "src/components/common/Icon";

import AppSettings from "./AppSettings";

/**
 * Creates a render callback bound to the supplied application icon definition.
 */
const formIconCreator = (icon: AppIconDefinition) => () => <Icon icon={icon} />;

/**
 * Supplies shared form icons and popover validation presentation.
 *
 * Assumptions: These are partial options merged by the form provider; table fields contain
 * validation errors within their configured boundary.
 */
const mantineFormOptions: DeepPartial<MantineFormOptions> = {
    icons: {
        delete: formIconCreator(AppSettings.icons.delete),
        validationError: {
            [ValidationErrorType.Description]: formIconCreator(AppSettings.icons.error.description),
            [ValidationErrorType.Information]: formIconCreator(AppSettings.icons.error.information),
            [ValidationErrorType.Warning]: formIconCreator(AppSettings.icons.error.warning),
            [ValidationErrorType.Low]: formIconCreator(AppSettings.icons.error.low),
            [ValidationErrorType.Medium]: formIconCreator(AppSettings.icons.error.medium),
            [ValidationErrorType.High]: formIconCreator(AppSettings.icons.error.high),
            [ValidationErrorType.Critical]: formIconCreator(AppSettings.icons.error.critical)
        }
    },
    fields: {
        groupedField: {
            validationErrorDisplayFormat: GroupedValidationErrorDisplayFormat.PopoverInput
        },
        groupedTableField: {
            groupedField: {
                validationErrorBoundary: {
                    mode: ValidationErrorBoundaryMode.Contain
                },
                validationErrorDisplayFormat: GroupedValidationErrorDisplayFormat.PopoverInput
            }
        }
    }
};

export default mantineFormOptions;
